import GenericRequest, { METHOD_PUT } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class AddPresenceTask extends GenericRequest {
    data = [];

    constructor(request) {
        super(METHOD_PUT, ApiEndpoints.WORKER_CONSTRUCTION_PRESENCE_ADD_IN_BATCH);
        this.data = request.data();
    }

    overrideRequest() {
        return this.data;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/webservices/add-presence/AddPresenceTask.js